/**
 * Created by jonlazarini on 06/05/17.
 */
export const initialState = {
    // slice of our state/reducer
    auth: {
        status: 'ANONYMOUS',
        email: null,
        displayName: null,
        photoURL: null,
        uid: null
    },
    messages: {
     /*   'firstMessage': {
            message: 'Marv Luvvhini est un peu un vier.',
            timeStamp: Date.now() - 600,
            uid: 'firstUser'
        },
        // from firebase
        'secondMessage': {
            message: 'Peut etre pas autant que Tromblonator, le roi des tromblons!',
            timeStamp: Date.now() - 540,
            uid: 'secondUser'
        }*/
    },
    users: {
    /*'firstUser': {
          displayName: 'Marv Zgegouz',
          email: 'trompette@kikou.com',
          photoURL: 'http://placehold.it/150x150'
      }*/
    },
    newMessage: ''
};



// WEBPACK FOOTER //
// ./src/initial-state.js